module.exports = __webpack_public_path__ + "static/media/squared.bc4cb7a5.jpg";